import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_CONTRACT_OVERVIEW } from "../../../api-setup/api-endpoints";

/**
 * Fetch contract overview data for a tenant
 * @param {Object} cookiesData - User credentials from cookies
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} - { success: boolean, data: array, error: string }
 */
export const fetchContractOverview = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
    };

    const response = await POSTAPI(false, GET_CONTRACT_OVERVIEW, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      // Transform the data to match the expected format for the grid
      const transformedData = response.data.row_result.map((item, index) => ({
        id: `${item.contract_mstr_key || index}-${index}`,
        division: item.division_name || "",
        hospital: item.location_name || "",
        contractType: item.contract_type || "",
        contractName: item.contract_name || "",
        providers: item.provider_name || "",
        providerCount: item.provider_count || "",
        startDate: item.start_date || "",
        endDate: item.end_date || "",
        contractValue: item.contract_value || "",
        specialty: item.specialty_name || "",
      }));

      return {
        success: true,
        data: transformedData,
        error: null,
      };
    } else {
      console.error("Failed to fetch contract overview:", response);
      return {
        success: false,
        data: [],
        error: response?.data?.out_parameters?.out_error_msg || "Failed to fetch contract overview data",
      };
    }
  } catch (error) {
    console.error("Error in fetchContractOverview:", error);
    return {
      success: false,
      data: [],
      error: error.message || "An error occurred while fetching contract overview",
    };
  }
};
